export default __webpack_public_path__ + "static/media/Aicoach.30ca44ee.png";